const twoDigitsFormat = (arg: number | string): string => {
    if (`${arg}`.length === 1) {
        return `0${arg}`;
    }

    return `${arg}`;
};

export default twoDigitsFormat;
